import Vue from "vue";
import dateFormats, { DEFAULT_DATETIME_FORMAT_MINUTES } from "@/static/dateFormats";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const filterFormatDateTimeMinutes = (value: string | Date): string => {
  if (!value) return "";
  return dayjs(value, dateFormats, false).format(DEFAULT_DATETIME_FORMAT_MINUTES);
};

Vue.filter("formatDateTimeMinutes", filterFormatDateTimeMinutes);
